import { render } from "./InputMoney.vue?vue&type=template&id=19e8689a"
import script from "./InputMoney.vue?vue&type=script&lang=js"
export * from "./InputMoney.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__